// Add your JS customizations here
console.log('custom javascript');

import events_gform from './components/events_gform';
import { Fancybox } from "@fancyapps/ui";

window.onload = function() {
    scrollFunction();
    events_gform();
    mobileMenu();
}

window.onscroll = function() {scrollFunction()};

/**
 * Add class to header when scroll
 */
const scrollFunction = () => {

    const $header = document.getElementById('wrapper-navbar');
    const headerHeight = $header.offsetHeight


    if (document.body.scrollTop > headerHeight || document.documentElement.scrollTop > headerHeight) {
        $header.classList.add('_pos-fixed');
    } else {
        $header.classList.remove('_pos-fixed');
    }
}

/**
 * Mobile menu behaviour
 */
const mobileMenu = () => {
    console.log(' mobile menu init ');

    const $btnMobileMenu = document.querySelector('.btn-mobile-menu');

    if( $btnMobileMenu ) {
        $btnMobileMenu.addEventListener('click', () => {

            console.log('clicker')

            if( $btnMobileMenu.classList.contains('active') ) {
                $btnMobileMenu.classList.remove('active');
            } else {
                $btnMobileMenu.classList.add('active');
            }
        });
    }
}

/**
 * Fancy Box
 */
window.initFancybox = () => {

    Fancybox.bind("[data-fancybox]", {
    });
}